import { Router, Routes } from "@/lib/router";
import { Navbar } from "@/components/Navbar";
import { BrowsePage } from "@/pages/BrowsePage";
import { ProjectPage } from "@/pages/ProjectPage";
import { UploadPage } from "@/pages/UploadPage";
import { LeaderboardPage } from "@/pages/LeaderboardPage";
import { TooltipProvider } from "@/components/ui/tooltip";
import "./index.css";

const routes = [
	{ path: "/", component: BrowsePage },
	{ path: "/project/:id", component: ProjectPage },
	{ path: "/upload", component: UploadPage },
	{ path: "/leaderboard", component: LeaderboardPage },
];

export function App() {
	return (
		<TooltipProvider>
			<Router>
				<div className="min-h-screen bg-background">
					<Navbar />
					<main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6">
						<Routes routes={routes} />
					</main>
				</div>
			</Router>
		</TooltipProvider>
	);
}

export default App;
